import { createElement, useEffect } from 'react';

const LOADER_SRC = 'https://widgets.leadconnectorhq.com/loader.js';
const RESOURCES_URL = 'https://widgets.leadconnectorhq.com/chat-widget/loader.js';
const SCRIPT_ID = 'boaz-ghl-chat-loader';

export default function PublicGhlChat({
  primaryColor,
  locationId,
  widgetId,
}: {
  primaryColor?: string | null;
  locationId?: string | null;
  widgetId?: string | null;
}) {
  const ghlLocationId = (locationId ?? '').trim();
  const ghlWidgetId = (widgetId ?? '').trim();

  useEffect(() => {
    if (!ghlLocationId) return;
    if (document.getElementById(SCRIPT_ID)) return;
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.src = LOADER_SRC;
    script.async = true;
    script.setAttribute('data-resources-url', RESOURCES_URL);
    if (ghlWidgetId) script.setAttribute('data-widget-id', ghlWidgetId);
    document.body.appendChild(script);
  }, [ghlLocationId, ghlWidgetId]);

  if (!ghlLocationId) return null;

  if (ghlWidgetId) {
    return (
      <div
        data-chat-widget
        data-location-id={ghlLocationId}
        data-widget-id={ghlWidgetId}
        style={primaryColor ? ({ ['--chat-widget-primary-color' as string]: primaryColor, ['--chat-widget-active-color' as string]: primaryColor }) : undefined}
      />
    );
  }

  return createElement('chat-widget', {
    'location-id': ghlLocationId,
    style: primaryColor ? ({ ['--chat-widget-primary-color' as string]: primaryColor, ['--chat-widget-active-color' as string]: primaryColor }) : undefined,
  });
}
